import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";
import { useCurrentWorkspaceContext } from "@v2/contexts/WorkspaceDashboardContext";

const useCurrentAnalyticsTimezone = () => {
  const { workspace } = useCurrentWorkspaceContext();
  const { project } = useCurrentProjectContext();

  return (
    project?.timeZone ??
    workspace?.timeZone ??
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
};

export default useCurrentAnalyticsTimezone;
